import { inject, provideAppInitializer } from '@angular/core'
import { MatIconRegistry } from '@angular/material/icon'
import { DomSanitizer } from '@angular/platform-browser'

/**
 * Registriert das HARTMANN-Signet als `<mat-icon svgIcon="hartmann">`. Vorbild: `provideWhatsappIcon()`
 * in `libs/shared`.
 *
 * Bewusst das SIGNET (Kreuz in der Ellipse) und nicht das volle Logo: auf Knopfhoehe war der
 * Schriftzug daneben ein zweites „Hartmann" neben dem, das schon im Text steht. Das volle Logo
 * bleibt dort, wo es Platz hat — in der leeren CCaaS-Liste (`hartmann-logo.svg`).
 */
export function provideHartmannIcon() {
  return provideAppInitializer(() => {
    const registry = inject(MatIconRegistry)
    const sanitizer = inject(DomSanitizer)
    registry.addSvgIcon('hartmann', sanitizer.bypassSecurityTrustResourceUrl('/assets/logos/hartmann-signet.svg'))
  })
}
